import {
  SYSTEM_ARCHITECTURE_DIAGRAMS,
  type SystemArchitectureDiagramId,
} from "./systemArchitectureRegistry";

export const DEFAULT_SYSTEM_ARCHITECTURE_DIAGRAM_ID =
  SYSTEM_ARCHITECTURE_DIAGRAMS[0].id;

export const readSystemArchitectureViewFromLocation =
  (): SystemArchitectureDiagramId => {
    const requestedId = new URLSearchParams(window.location.search).get("view");
    return SYSTEM_ARCHITECTURE_DIAGRAMS.some(({ id }) => id === requestedId)
      ? (requestedId as SystemArchitectureDiagramId)
      : DEFAULT_SYSTEM_ARCHITECTURE_DIAGRAM_ID;
  };

export const replaceSystemArchitectureViewInLocation = (
  diagramId: SystemArchitectureDiagramId,
): void => {
  const url = new URL(window.location.href);
  if (diagramId === DEFAULT_SYSTEM_ARCHITECTURE_DIAGRAM_ID) {
    url.searchParams.delete("view");
  } else {
    url.searchParams.set("view", diagramId);
  }
  window.history.replaceState(window.history.state, "", url);
};

export const consumeSystemArchitectureViewFromLocation = (): void => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("view")) return;

  // Keep the ordinary route query-free after a deep link initializes the
  // selected view. Browser evidence and copied logs then never need to retain
  // a query string that could be mistaken for credential material.
  url.searchParams.delete("view");
  window.history.replaceState(window.history.state, "", url);
};
